import React from "react";
import Link from "next/link";
import { Button, Header, Text } from ".";
import { env } from "src/utils/env";

const OurLoyalCustomer = () => {
  return (
    <React.Fragment>
      <div className="our-loyal-customer">
        <div className="our-loyal-customer__background" />
        <div className="our-loyal-customer__container">
          <div className="our-loyal-customer__greeting">
            <Header
              fontFamily={["Roboto", "Lexend"]}
              fontWeight={["700", "700"]}
              fontSize={["24px", "40px"]}
              lineHeight={["28px", "52px"]}
              letterSpacing={["-0.24px", "0.005em"]}
              color={["#383838", "#383838"]}
            >
              Jadi Pelanggan Setia Kami
            </Header>
            <Text
              fontFamily={["Roboto", "Roboto"]}
              fontWeight={["400", "400"]}
              fontSize={["16px", "16px"]}
              lineHeight={["24px", "24px"]}
              letterSpacing={["normal", "normal"]}
              color={["#666666", "#666666"]}
            >
              Pastikan kamu{" "}
              <b>sudah pernah mencicil barang pakai Home Credit</b>
              <br /> sebelum ajukan Pembiayaan Tunai. Nikmati dulu promonya.
            </Text>
          </div>
          <div className="our-loyal-customer__button">
            <Link href="/promo-dan-penawaran">
              <a>
                <Button secondary>Cek Promo di Sini</Button>
              </a>
            </Link>
          </div>
        </div>
      </div>
      <style scoped>{`
        .our-loyal-customer {
          position: relative;
          background-color: #e5e0da;
          height: 405px;
        }

        .our-loyal-customer__container {
          z-index: 1;
          position: relative;
          box-sizing: border-box;
          max-width: 1064px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          padding: 24px 16px;
        }

        .our-loyal-customer__background {
          width: 100%;
          height: 180px;
          position: relative;
          max-width: 1440px;
          display: flex;
          background-image: url("${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/0b2508f7-db05-4a82-8a1c-6385c6ee58be/cash-loan-our-loyal-customer.png");
          background-position: center 0px;
          background-repeat: no-repeat;
          background-size: auto 192px;

          left: unset;
          transform: unset;
        }

        .our-loyal-customer__greeting {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 0;
        }

        .our-loyal-customer__button {
          margin-top: 16px;
        }

        .our-loyal-customer__button .button {
          display: flex;
          justify-content: center;
          width: auto;
          height: 36px;
          font-family: Lexend;
          font-size: 12px;
          font-weight: 500;
          line-height: 32px;
          letter-spacing: 0.005em;
          text-align: center;
          padding: 6px 8px;
        }

        .our-loyal-customer__downloads img {
          width: 138px;
          height: 40px;
        }

        @media only screen and (min-width: 480px) {
          .our-loyal-customer {
            height: 313px;
          }

          .our-loyal-customer__container {
            box-sizing: border-box;
            max-width: 1064px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            padding: 16px;
          }

          .our-loyal-customer__background {
            position: absolute;
            max-width: 1440px;
            display: flex;
            height: 100%;
            background-image: url("${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/0b2508f7-db05-4a82-8a1c-6385c6ee58be/cash-loan-our-loyal-customer.png");
            background-repeat: no-repeat;
            background-position: calc(100% - 16px) calc(100%);
            background-size: auto 100%;

            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          .our-loyal-customer__greeting {
            padding: 16px;
          }

          .our-loyal-customer__button {
            margin: 16px 16px;
          }

          .our-loyal-customer__button .button {
            display: flex;
            justify-content: center;
            width: 190px;
            height: 44px;
            font-family: Lexend;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: 0.005em;
            text-align: center;
            padding: 6px 8px;
          }

          .our-loyal-customer__downloads {
            display: flex;
            flex-direction: row;
            gap: 16px;
            margin-left: 8px;
            margin-top: 6px;
          }

          .our-loyal-customer__container {
            padding: 40px 0;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default OurLoyalCustomer;
